import type { WasteCarrier } from 'portal/store/interfaces'

export const CARRIERS_LOAD = 'CARRIERS_LOAD'
export const carriersLoad = (hint: string | null): carriersLoadAction => ({
  type: CARRIERS_LOAD,
  hint: hint
})

export const CARRIERS_LOAD_CONTINUATION = 'CARRIERS_LOAD_CONTINUATION'
export const carriersLoadContinuation = (
  hint: string | null,
  continuationToken: string | null
): carriersLoadContinuationAction => ({
  type: CARRIERS_LOAD_CONTINUATION,
  hint: hint,
  continuationToken: continuationToken
})

export const CARRIERS_LOAD_SUCCESS = 'CARRIERS_LOAD_SUCCESS'
export const carriersLoadSuccess = (
  carriers: WasteCarrier[],
  continuationToken: string | null,
  hasNextPage: boolean
): carriersLoadSuccessAction => ({
  type: CARRIERS_LOAD_SUCCESS,
  carriers,
  continuationToken,
  hasNextPage
})

export const CARRIERS_LOAD_FAIL = 'CARRIERS_LOAD_FAIL'
export const carriersLoadFailure = (error): carriersLoadFailAction => ({
  type: CARRIERS_LOAD_FAIL,
  error
})

// INTERFACEs

export interface carriersLoadAction {
  type: typeof CARRIERS_LOAD
  hint: string | null
}

export interface carriersLoadContinuationAction {
  type: typeof CARRIERS_LOAD_CONTINUATION
  hint: string | null
  continuationToken: string | null
}

interface carriersLoadSuccessAction {
  type: typeof CARRIERS_LOAD_SUCCESS
  carriers: WasteCarrier[]
  continuationToken: string | null
  hasNextPage: boolean
}

interface carriersLoadFailAction {
  type: typeof CARRIERS_LOAD_FAIL
  error: any
}
